import { createUseStyles } from "react-jss";

export default createUseStyles({
    variableContainer: {
        fontSize: "13px",
        fontFamily: "Open Sans",
        borderBottom: "1px solid #eee",
        padding: [[10, 0]],
    },
    variablePanelHeader: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "flex-end",
    },
    variablePanelHeaderTitle: {
        marginRight: "auto",
    },
    variableValue: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    variableName: {
        marginRight: "auto",
        wordBreak: "break-all",
    },
    variableDetails: {
        paddingRight: 29,
        overflow: "hidden",
        boxSizing: "border-box",
    },
    variableInput: {
        width: "100%",
        background: "#333E5B",
        fontSize: "12px",
        outline: "none",
        color: "white",
        border: 0,
        borderRadius: 5,
        padding: [[6, 10]],
        boxSizing: "border-box",
        resize: "none",

        "&:active, &:focus": {
            color: "#F68A5A",
        },
    },
    variableInputSmall: {
        fontSize: "12px",
        width: 100,
        outline: "none",
        border: 0,
        background: "#333E5B",
        color: "white",
        textAlign: "right",
        padding: [[6, 10]],
        marginLeft: 5,
        marginRight: 6,
        borderRadius: 5,

        "&:active, &:focus": {
            color: "#F68A5A",
        },
    },
    variableText: {
        margin: [[5, 0]],
        fontWeight: 700,
        fontSize: "10px",
    },
    variableOpenEnd: {
        margin: [[5, 0]],
        marginTop: 10,
        fontWeight: 700,
        fontSize: "10px",
    },
    variableDetailsIcon: {
        fontSize: "12px",
        padding: 4,
        cursor: "pointer",
        userSelect: "none",
    },
    variableDetailsIconActive: {
        color: "#00A9E8",
    },
    variableTypeButton: {
        padding: [[0, 10]],
        cursor: "pointer",
        marginRight: "auto",
    },
});
